import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../common';
import { AuthService } from '../../services';
import { HttpErrorResponse } from '@angular/common/http';
import { IResponseMessage } from '../../models';

@Component({
  selector: 'app-token-handler',
  imports: [],
  templateUrl: './token-handler.component.html',
  styleUrl: './token-handler.component.scss'
})
export class TokenHandlerComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      const token = params.get('token');
      if (token) {
        this.authService.validateImpersonateJwtToken(token).subscribe({
          next: (response: { user_token: string }) => {
            if (response.user_token) {
              // console.log(response.user_token);
              localStorage.setItem(Constants.localStorageItem.token, response.user_token);
              // After setting token, reload the full browser window
              // window.location.reload();
              this.router.navigate(['/']).then(() => {
                // Optionally reload the page if needed
                window.location.reload();
              });
            }
            else {
              this.authService.logout();
            }

          },
          error: (error: HttpErrorResponse) => {
            console.log(error);
            this.authService.logout();
          }
        })
      }
    });
  }
}
